import { Icon } from '../../../UI'

import greenCheckmarkFlat from 'assets/icon/green-checkmark-flat.svg'

const TestInstructionItem = ({ type = 'check', children }) => {
  return (
    <li className="flex items-start justify-start !mb-5 !last:mb-0">
      {type === 'check' ? (
        <div className="w-6 h-6 mr-[6px] inline-flex items-center justify-center">
          <img src={greenCheckmarkFlat} alt="checkmark" />
        </div>
      ) : (
        type === 'warning' && (
          <Icon name="warning-triangle" color="#f79009" className="w-6 h-6 mr-[6px]" />
        )
      )}

      <div className="flex-1">{children}</div>
    </li>
  )
}

export default TestInstructionItem
